export default "__VITE_ASSET__Hq$44Ghi__"